import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs'; // Import EMPTY
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { DynamicSnacbarErrorComponent } from '../container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { Helper } from '../helper/defult';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  userDeatilsToken: any = '';
  // Add your logout endpoint here to prevent the loop
  excludeURL = ['auth/logout', 'logout', 'signout'];
  private isLoggingOut = false;

  constructor(
    private _authService: AuthService,
    private helper: Helper,
    private dialogRef: MatDialog,
    private snackBar: MatSnackBar
  ) {
    // Constructor logic remains the same...
    let localUsertoken = localStorage.getItem('workNigeriaToken');
    let sessionUsertoken = sessionStorage.getItem('workNigeriaToken');
    if (localUsertoken) {
      this.userDeatilsToken = this._authService.getToken();
    }
    if (sessionUsertoken) {
      this.userDeatilsToken = this._authService.getTokenFormseesion();
    }
  }

  private handleSessionExpired(): void {
    if (this.isLoggingOut) {
      return;
    }

    this.isLoggingOut = true;
    localStorage.removeItem('workNigeriaToken');
    sessionStorage.removeItem('workNigeriaToken');

    this.snackBar
      .openFromComponent(DynamicSnacbarErrorComponent, {
        data: 'Session has expired',
        verticalPosition: 'top',
        horizontalPosition: 'right',
        duration: 3000,
      })
      .afterOpened()
      .subscribe(this.helper.setOnTop);

    // Now call the service logout (mostly for routing logic now)
    this._authService.allLogout();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // ignore incoming requests or pass them without error handling
    if (this.isLoggingOut) {
      return next.handle(request).pipe(
        catchError(() => EMPTY) // Suppress errors to prevent noise
      );
    }

    // skip the interceptor logic to prevent the "Logout Loop"
    // (Check if request.url contains any string from excludeURL)
    if (this.excludeURL.some((url) => request.url.includes(url))) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          // check safety of body exists
          let error =
            body && body.serverResponse ? body.serverResponse.code : 'error';

          if (error == 403) {
            this.handleSessionExpired();
            // Don't return the event if it's an error, helps prevent downstream processing
          }
          return event;
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        // Handle actual HTTP 401/403 status codes
        if (error.status === 401 || error.status === 403) {
          this.handleSessionExpired();

          // If it's a 401/403, we generally want to stop the component
          // from trying to render data that isn't there.
          return throwError(() => error);
        }

        // Handle other errors (500, 404, etc)
        if (!error.ok) {
          this.snackBar
            .openFromComponent(DynamicSnacbarErrorComponent, {
              data: 'Something went wrong',
              verticalPosition: 'top',
              horizontalPosition: 'right',
              duration: 6000,
            })
            .afterOpened()
            .subscribe(this.helper.setOnTop);
        }

        return throwError(() => error);
      })
    );
  }
}
